export default __webpack_public_path__ + "083a21984283bf83d4e813327073ac19.woff";